
import { createI18n } from "vue-i18n";

function loadLocaleMessages() {
  const messages = {};
  const locales = import.meta.glob("./locales/*.json", { eager: true });

  for (const path in locales) {
    const matched = path.match(/([A-Za-z0-9-_]+)\.json$/i);
    if (matched && matched[1]) {
      const locale = matched[1];
      messages[locale] = locales[path];
    }
  }

  return messages;
}

export default createI18n({
  legacy: false,
  globalInjection: true,
  locale: import.meta.env.VITE_I18N_LOCALE || "en",
  fallbackLocale: import.meta.env.VITE_I18N_FALLBACK_LOCALE || "en",
  messages: loadLocaleMessages(),
});
